import React from "react";
import logo from "../../assets/tfd.png"; // Update the path if needed

const Verified = ({ isVerified }) => {
  if (!isVerified) {
    return null;
  }

  return (
    <div className="court-item-verified flex items-center gap-1 text-sm font-semibold text-green-800 bg-green-100 px-2 py-1 rounded">
      <img src={logo} alt="Logo" className="h-[1em] w-auto align-middle" />
      <span>APPROVED ✔️</span>
    </div>
  );
};

export default Verified;
